<template>
    <div class="fluid">
        <h1 class="app-title">Gerar Requisição - Honorários De Ação Judicial</h1>
        <b-card>
            <b-row no-gutters>
                <b-col md="12" no-gutters>
                    <form-wizard
                            ref="wizard"
                            nextButtonText="Próximo"
                            backButtonText="Anterior"
                            finishButtonText="Concluir"
                            title
                            subtitle
                            color="#0A9C70" >
                        <wizard-step
                                slot-scope="props"
                                slot="step"
                                :tab="props.tab"
                                :index="props.index"
                        ></wizard-step>
                        <tab-content
                                icon="fas fa-id-card"
                                class="mx-auto"
                                title="Indicar o Processo">
                            <p class="mb-2">Informe o número do processo:</p>
                            <b-row>
                                <b-col sm="12" md="4">
                                    <b-form-group
                                            label="Número CNJ:"
                                            label-for="cnj"
                                            class="text-label"
                                            description="Somente os números">
                                        <b-form-input
                                                type="text"
                                                id="cnj"
                                                v-model="filtros.cnj"
                                                v-mask="['#######-##.####.#.##.####']"
                                                :class="!validations.cnj.valid ? 'is-invalid cnj' : 'cnj'"
                                                @keyup.enter="enterCnj()"
                                                @change="completarCnj();"
                                        ></b-form-input>
                                        <div v-if="!validations.cnj.valid" class="invalid-message">Número CNJ inválido!</div>
                                    </b-form-group>
                                </b-col>
                            </b-row>
                        </tab-content>
                        <tab-content
                                icon="fas fa-clipboard-check"
                                class="mx-auto"
                                title="Histórico de Requisições" >
                            <TabelaPesquisas
                                    :resultado="items"
                                    :configTable="configTable"
                                    :filtroComponente="filtro"
                                    :filtros="filtros"
                                    :loading="$refs.loading"
                                    :cnj="filtros.cnj"
                                    :selecteds="selecteds"
                                    @prevTab="prevTab"
                                    @nextStep="nextStep"
                                    @openFilterPopup="openFilterPopup"
                                    @consultar="consultar"
                                    @consultarComScroll="(update) => { updated = update; consultarComScroll() }"
                                    @limparFiltros="limparFiltros"
                                    @obterHonorariosAcaoJudicial="obterHonorariosAcaoJudicial"
                                    @alterarTitularReceita="alterarTitularReceita"/>
                        </tab-content>
                        <tab-content
                                icon="fas fa-funnel-dollar"
                                class="mx-auto"
                                title="Definir Parâmetros de Cálculo">
                            <ParametrosCalculo
                                    ref="parametrosCalculo"
                                    :items="itemsTodos"
                                    :cnj="filtros.cnj"
                                    :selecteds="selecteds"
                                    :devedores="devedores"
                                    :listaContribuintes="listaContribuintes"
                                    :devedor="devedor"
                                    :requisicao="requisicao"
                                    :faixas="faixas"
                                    :regrasPagamento="regrasPagamento"
                                    :validationsPrincipal="validations"
                                    @limparDevedor="limparDevedor"
                                    @voltarFaixas="voltarFaixas"
                                    @excluirDevedor="excluirDevedor"
                                    @alterarValidadeValor="alterarValidadeValor"
                            />
                        </tab-content>
                        <tab-content
                                icon="fas fa-file-invoice-dollar"
                                class="mx-auto"
                                title="Confirmar Geração da Requisição">
                            <ConfirmarGeracao
                                    ref="abaConfirmar"
                                    :cnj="filtros.cnj"
                                    :requisicao="requisicao"
                                    :devedores="devedores"
                                    :listaContribuintes="listaContribuintes"
                                    :devedor="devedor"
                                    :acessoLimitado="acessoLimitado"
                                    :submeterProcurador="submeterProcurador"
                                    @limparAnexos="limparAnexos"
                                    @executeUpload="executeUpload"
                                    @excluirArquivo="excluirArquivo"
                                    @exportarMemoria="exportarMemoria"
                                    @salvar="salvar"
                                    @alterarSubmeterProcurador="alterarSubmeterProcurador"
                            />
                        </tab-content>
                        <tab-content
                                icon="fas fa-money-check-alt"
                                class="mx-auto"
                                title="Requisição Gerada">
                            <Conclusao
                                ref="abaConclusao"
                                :cnj="filtros.cnj"
                                :lista-requisicao="retorno.id"
                                :requisicao="requisicao"
                                :nova="requisicao.codRequisicaoRepresentacaoJudicial == null"
                                :arquivoPdf="arquivoPdf"
                            />
                        </tab-content>

                        <template slot="footer" slot-scope="props" class="pb-0">
                            <hr class="mt-0 mb-2"/>
                            <div class="row justify-content-between">
                                <b-col sm="12" md="2">
                                    <b-button
                                            v-if="props.activeTabIndex > 1 && !props.isLastStep"
                                            @click="prevTab"
                                            variant="secondary" >
                                        <i class="fa fa-arrow-left"></i> Anterior
                                    </b-button>
                                </b-col>
                                <b-col sm="12" md="2" class="text-right" v-if="props.activeTabIndex != 1 && props.activeTabIndex < 3">
                                    <b-button
                                            id="btnProxima"
                                              @click="nextStep"
                                              :disabled="!cnjValido || (props.activeTabIndex == 2 && !validations.valor.valid)"
                                              variant="primary">
                                        Próxima
                                        <i class="fa fa-arrow-right"></i>
                                    </b-button>
                                </b-col>
                                <b-col sm="12" md="2" class="text-right" v-if="props.activeTabIndex == 4">
                                    <b-button class="finish-button" variant="success" @click="sair">
                                        Concluir
                                        <i class="fas fa-flag-checkered"></i>
                                    </b-button>
                                </b-col>
                                <b-col sm="12" md="6" class="text-right" v-if="props.activeTabIndex == 3">
                                    <b-button variant="secondary" @click="sair" class="mr-2">
                                        <i class="fas fa-sign-out-alt"></i>
                                        Sair Sem Gerar Requisição
                                    </b-button>
                                    <b-button variant="warning" @click="salvar(false)" :disabled="(acessoLimitado && submeterProcurador) || $refs.abaConfirmar.total() <= 0">
                                        <i class="fa fa-file-pdf"></i>
                                        Confirmar Geração da Requisição
                                    </b-button>
                                </b-col>
                            </div>
                        </template>
                    </form-wizard>
                </b-col>
            </b-row>
        </b-card>
        <b-modal
                ref="modal-datas"
                id="modal-datas"
                size="xl"
                :content-class="'shadow ' + getTheme"
                title="Datas de Correção"
                header-bg-variant="success"
                header-text-variant="white">
            <b-row class="mt-3">
                <b-col xs="12" md="12" class="mx-auto">
                    <p style="font-weight: bold;">Não foram indicadas as datas Início da Correção e Fim da Correção. Ao clicar no botão Próxima, essa configuração fará com que os pagamentos anteriores sejam atualizados, mas não sofrerá atualização o valor de honorários informados (Honorários em Valor Fixo) ou calculados (Honorários sobre Base de Cálculo). Para atualizar também os honorários informados ou calculados, clique no botão Preencher Datas e preencha os campos Início da Correção e Fim da Correção.</p>
                </b-col>
            </b-row>
            <template v-slot:modal-footer="{ hide }">
                <b-button variant="outline-primary" @click="hide('modal-datas')" class="mr-2"> <i class="far fa-calendar-alt"></i> Preencher Datas</b-button>
                <b-button variant="outline-secondary" @click="avancaTerceiraAba"> <i class="fas fa-arrow-right"></i> Prosseguir</b-button>
            </template>
        </b-modal>
        <b-modal
                ref="modal-avancar-ef"
                id="modal-avancar-ef"
                size="xl"
                :content-class="'shadow ' + getTheme"
                title="Número CNJ de Execução Fiscal D.A. SEFA"
                header-bg-variant="info"
                header-text-variant="white">
            <b-row class="mt-3">
                <b-col xs="12" md="12" class="mx-auto">
                    <p>O número CNJ informado consta na base do PROAJU como Execução Fiscal de D.A. inscrita pela SEFA!</p>
                    <p>Para gerar requisição de honorários provenientes de executivo fiscal de D.A. inscrita pela SEFA, utilize o fluxo <i>2) Honorários de Execução Fiscal D.A. SEFA</i>.</p>
                </b-col>
            </b-row>
            <template v-slot:modal-footer="{ hide }">
                <b-button variant="primary" @click="hide('modal-avancar-ef')"> Fechar</b-button>
            </template>
        </b-modal>
        <b-modal
                ref="modal-confirmar-data"
                id="modal-confirmar-data"
                size="xl"
                :content-class="'shadow ' + getTheme"
                title="Verificar Data de Ajuizamento"
                header-bg-variant="info"
                header-text-variant="white">
            <b-row class="mt-3">
                <b-col xs="12" md="12" class="mx-auto">
                    <p>ATENÇÃO! VERIFICAR A DATA DE AJUIZAMENTO!</p>
                    <p>Pelo ano do processo informado, é possível que os honorários sucumbenciais sejam <b>devidos à Caixa Especial de Sucumbência – CES</b> e não ao FEPGE (arts. 150 e 151 do Manual de Procedimentos da PGE). Sendo esta a hipótese (honorários devidos à CES), clique em "Voltar" e, em seguida, em "Sair sem gerar Requisição".</p>
                    <p>De outro modo, tratando-se de honorários efetivamente devidos ao FEPGE, clique em "Confirmar a Geração".</p>
                </b-col>
            </b-row>
            <template v-slot:modal-footer="{ hide }">
                <b-button variant="secondary" @click="hide('modal-confirmar-data')"> Voltar</b-button>
                <b-button variant="warning" @click="finalizarConfirmar(false)"> <i class="fa fa-file-pdf"></i> Confirmar a Geração</b-button>
            </template>
        </b-modal>
        <b-modal
                ref="modal-confirmar-data-fepge"
                id="modal-confirmar-data-fepge"
                size="xl"
                :content-class="'shadow ' + getTheme"
                title="ATENÇÃO! VERIFICAR A DATA DE AJUIZAMENTO"
                header-bg-variant="info"
                header-text-variant="white">
            <b-row class="mt-3">
                <b-col xs="12" md="12" class="mx-auto">
                    <p>O ano do processo envolvido no cálculo desta Requisição é 2016 ou posterior, sendo possível que os honorários sucumbenciais relativos a tal processo sejam devidos à Caixa Especial de Sucumbência – CES e não ao FEPGE (conforme Manual de Procedimentos da PGE).</p>
                    <p>Clique em "Continuar" somente se os honorários do processo envolvido no cálculo objeto desta Requisição forem devidos ao FEPGE. Caso os honorários sejam devidos à CES, clique em "Voltar" e selecione a opção "2) CES - Caixa Especial de Sucumbência”.</p>
                </b-col>
            </b-row>
            <template v-slot:modal-footer="{ hide }">
                <b-button variant="secondary" @click="hide('modal-confirmar-data-fepge')"> Voltar</b-button>
                <b-button variant="primary" @click="forcarSegundaAba()"> Continuar</b-button>
            </template>
        </b-modal>
        <b-modal
                ref="modal-confirmar-data-ces"
                id="modal-confirmar-data-ces"
                size="xl"
                :content-class="'shadow ' + getTheme"
                title="ATENÇÃO! VERIFICAR A DATA DE AJUIZAMENTO"
                header-bg-variant="info"
                header-text-variant="white">
            <b-row class="mt-3">
                <b-col xs="12" md="12" class="mx-auto">
                    <p>O ano do processo envolvido no cálculo desta Requisição é 2016 ou anterior, sendo possível que os honorários sucumbenciais relativos a tal processo sejam devidos ao FEPGE e não à Caixa Especial de Sucumbência – CES (conforme Manual de Procedimentos da PGE).</p>
                    <p>Clique em "Continuar" somente se os honorários do processo envolvido no cálculo objeto desta Requisição forem devidos à Caixa Especial de Sucumbência. Caso os honorários sejam devidos ao FEPGE, clique em "Voltar" e selecione a opção “1) FEPGE - Fundo Especial da PGE”.</p>
                </b-col>
            </b-row>
            <template v-slot:modal-footer="{ hide }">
                <b-button variant="secondary" @click="hide('modal-confirmar-data-ces')"> Voltar</b-button>
                <b-button variant="primary" @click="forcarSegundaAba()"> Continuar</b-button>
            </template>
        </b-modal>
        <CompLoading ref="loading"/>
        <CompFiltroGrid
                ref="compFiltro"
                :filtro="filtro"
                @filtrarResultados="filtrarResultados"
                @ordenarResultados="ordenarResultados"/>
    </div>
</template>

<script>
    import {FormWizard, TabContent, WizardStep} from 'vue-form-wizard';
    import formatarMixins from '../../mixins/formatarMixins';

    import axios from 'axios';
    import 'vue-form-wizard/dist/vue-form-wizard.min.css';
    import TabelaPesquisas from "./components/TabelaPesquisas";
    import ParametrosCalculo from "./components/ParametrosCalculo";
    import CompLoading from "../shared/components/CompLoading";
    import CompFiltroGrid from "../shared/components/CompFiltroGrid";
    import ConfirmarGeracao from "./components/ConfirmarGeracao";
    import Conclusao from "./components/Conclusao";
    import moment from 'moment'

    export default {
        mixins: [ formatarMixins ],
        components: {
            Conclusao,
            ConfirmarGeracao,
            TabelaPesquisas,
            ParametrosCalculo,
            FormWizard,
            TabContent,
            WizardStep,
            CompLoading,
            CompFiltroGrid
        },
        data() {
            return {
                updated: false,
                urlApi: null,
                token: null,
                cnjValido: true,
                acessoLimitado: null,
                currentScroll: null,
                submeterProcurador: false,
                selecteds: [],
                items: [],
                itemsTodos: [],
                configTable: {
                    perPage: 10,
                    lastPage: null,
                    sortField: 'requisicao.numeroRequisicao',
                    sortOrder: 'desc',
                    currentPage: 1,
                    rows: 0,
                    checkedAll: false,
                    load: false,
                },
                filtro: {
                    tipo: null,
                    campoFiltro: null,
                    filtrarEm: null,
                    campoTexto: null,
                    campoData: null,
                    campoRadio: null,
                    campoCheckbox: null,
                    listaValores: []
                },
                filtros: {
                    numeroRequisicao: null,
                    cnj: null,
                    filtrarContribuinte: null,
                    contribuinte: null,
                    filtrarDataEmissao: null,
                    dataEmissao: null,
                    tipoPagamento: null,
                    formaPagamento: null,
                    filtrarValor: null,
                    valor: null,
                    situacao: null,
                    titularReceita: 0
                },
                load: false,
                devedores: [],
                listaContribuintes: [],
                devedor: {
                    codDevedor: null,
                    cpfCnpj: null,
                    nome: null,
                    cota: null,
                },
                requisicao: {
                    codRequisicaoRepresentacaoJudicial: null,
                    honorarioFixo: null,
                    valorFixo: null,
                    valorBaseCalculo: null,
                    percentual: null,
                    valorIndice: null,
                    dataSentenca: null,
                    salarioMinimo: null,
                    quantidadeSalarios: null,
                    indiceCorrecao: null,
                    indiceJuros: null,
                    inicioCorrecao: null,
                    inicioJuros: null,
                    fimCorrecao: null,
                    fimJuros: null,
                    multaArtCpc: null,
                    honorariosArtCpc: null,
                    deduzirPagamentos: false,
                    tipoPagamento: null,
                    regraParcelamento: null,
                    numeroParcelas: null,
                    numeroParcelasFixo: null,
                    indiceReajuste: null,
                    formaPagamento: null,
                    deliberacao: null,
                    sid: null,
                    valorHonorariosArtigo: null,
                    numeroMinimoParcelas: null,
                    numeroMaximoParcelas: null,
                    valorJuros: null,
                    valorCorrecao: null,
                    requisicoesDeducao: null,
                    valoresAnteriores: null,
                    enviarDocumentacao: false,
                    emitirTermo: null,
                    arquivos: [],
                    setor: null,
                    procurador: null,
                    email: null,
                    pagamento: null,
                    dataTransferencia: null,
                    modalDatas: false,
                },
                retorno: {
                    id: [],
                    arquivo: null
                },
                faixas: [],
                regrasPagamento: [],
                validations: {
                    cnj: { valid: true },
                    valor: { valid: true }
                },
                arquivoPdf: null,
                emailCes: null
            }
        },
        computed: {
            getTheme () {
                return this.$store.getters.getTheme
            }
        },
        methods: {
            nextStep() {
                if(this.$refs.wizard.activeTabIndex == 0) {
                    this.avancaPrimeiraAba();
                } else if(this.$refs.wizard.activeTabIndex == 1) {
                    if(this.filtros.titularReceita == 0 && parseInt(this.filtros.cnj.substring(11, 15)) >= 2016) {
                        this.$refs['modal-confirmar-data-fepge'].show();
                    } else if(this.filtros.titularReceita == 1 && parseInt(this.filtros.cnj.substring(11, 15)) < 2016) {
                        this.$refs['modal-confirmar-data-ces'].show();
                    } else {
                        this.forcarSegundaAba();
                    }
                } else if(this.$refs.wizard.activeTabIndex == 2) {
                    if(this.requisicao.tipoPagamento == 1) {
                        this.requisicao.emitirTermo = true;
                    } else {
                        this.requisicao.emitirTermo = false;
                    }
                    this.$refs.abaConfirmar.atualizarSetor();
                    this.avancaTerceiraAba();
                }
                this.atribuirStickyTopo(false);
                window.scrollTo(0,0);
            },

            prevTab() {
                this.$store.commit("setMessages", {});

                if(this.$refs.wizard.activeTabIndex == 2) {
                    this.consultar();
                }
                this.$refs.wizard.prevTab();
                this.atribuirStickyTopo(false);
            },

            forcarSegundaAba() {
                this.$refs['modal-confirmar-data-fepge'].hide();
                this.$refs['modal-confirmar-data-ces'].hide();

                this.requisicao.titularReceita = this.filtros.titularReceita;
                this.requisicao.formaPagamento = null;
                if(this.requisicao.titularReceita == 1) {
                    for(let i = 0; i < this.regrasPagamento.length; i++) {
                        if(this.regrasPagamento[i].descricao.trim().toUpperCase() == 'À VISTA') {
                            this.requisicao.tipoPagamento = 0;
                            this.requisicao.pagamento = this.regrasPagamento[i];
                        }
                    }
                }

                this.$refs.parametrosCalculo.executarCalculos();
                this.$refs.wizard.nextTab();
                setTimeout(()=>{
                    this.$refs.parametrosCalculo.$forceUpdate();
                }, 100);
            },

            avancaPrimeiraAba() {
                this.$store.commit("setMessages", {});

                if(this.filtros.cnj == null || this.filtros.cnj.trim() == "" || this.filtros.cnj.length < 25 || !this.validaCnj(this.filtros.cnj)) {
                    this.validations.cnj.valid = false;
                    return;
                }

                this.validations.cnj.valid = true;

                axios.get(`${this.urlApi}/v1/honorariosAcaoJudicial/verificarExistenciaProcesso/` + this.filtros.cnj, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': this.token
                    }
                }).then(response => {
                    if(response.data) {
                        this.cnjValido = false;
                        this.$refs['modal-avancar-ef'].show();
                    } else {
                        this.cnjValido = true;
                        this.confirmarAvancarPrimeiraAba();
                    }
                }).catch((error) => {
                    this.exibirErro(error)
                }).finally(() => {
                    this.$refs.loading.hideLoading();
                });
            },

            confirmarAvancarPrimeiraAba() {
                this.$refs['modal-avancar-ef'].hide();

                this.$refs.wizard.nextTab();

                this.consultar();
                this.listarTodos();
            },

            adicionarEmailDevedor(devedor, emails) {
                if(devedor.email != null && devedor.email != "") {
                    emails = (emails != null ? emails + ', ' : '') + devedor.email;
                }
                if(devedor.emailAlternativo1 != null && devedor.emailAlternativo1 != "") {
                    emails = (emails != null ? emails + ', ' : '') + devedor.emailAlternativo1;
                }
                if(devedor.emailAlternativo2 != null && devedor.emailAlternativo2 != "") {
                    emails = (emails != null ? emails + ', ' : '') + devedor.emailAlternativo2;
                }
                return emails;
            },

            avancaTerceiraAba() {
	            this.requisicao.email = null;
	            if(this.requisicao.titularReceita == 1 && this.requisicao.formaPagamento === 3) {
		            this.requisicao.email = this.emailCes;
	            } else {
		            this.requisicao.email = this.adicionarEmailDevedor(this.devedor, this.requisicao.email);
		            this.devedores.forEach(el => {
			            this.requisicao.email = this.adicionarEmailDevedor(el, this.requisicao.email);
		            });
	            }

                if(this.requisicao.email != null && this.requisicao.email != '') {
                    this.requisicao.enviarDocumentacao = true;
                }

                this.$refs['modal-datas'].hide();
                if(this.requisicao.indiceCorrecao != null && !this.requisicao.modalDatas &&
                    (this.requisicao.inicioCorrecao == null || this.requisicao.inicioCorrecao == "") &&
                    (this.requisicao.fimCorrecao == null || this.requisicao.fimCorrecao == "") &&
                    this.requisicao.deduzirPagamentos == true) {
                    this.$refs['modal-datas'].show();
                    this.requisicao.modalDatas = true;
                } else if(this.$refs.parametrosCalculo.executarCalculos() && this.validarDatasRequisicao()) {
                    this.$refs.parametrosCalculo.invalidateDataTransferencia(true);
                    if(!this.$refs.parametrosCalculo.verificarObrigatoriedade()) {
                        return;
                    }

                    if(this.requisicao.tipoPagamento == 0 && this.requisicao.formaPagamento == 2 && !moment(this.requisicao.dataTransferencia, "YYYY-M-D", true).isValid()) {
                        this.$refs.parametrosCalculo.invalidateDataTransferencia(false);
                        return;
                    }

                    if(this.devedor.codDevedor == null) {
                        this.exibirMensagem('Informe um devedor existente ou inclua um novo');
                        return;
                    }
                    if(this.requisicao.honorarioFixo == false && this.requisicao.percentual && !this.$refs.parametrosCalculo.verificarFaixasInformadas()) {
                        this.exibirMensagem('As porcentagens segundo o Art 85 devem ser corretamente preenchidas.');
                        return;
                    }

                    let cotas = parseFloat(this.devedor.cota != null ? this.devedor.cota.toString().replace(",", ".") : 0);
                    for(var i = 0; i < this.devedores.length; i++){
                        cotas += parseFloat(this.devedores[i].cota != null ? this.devedores[i].cota.toString().replace(",", ".") : 0);
                    }

                    if(this.devedores.length > 0 && cotas != parseFloat(100)) {
                        this.$refs.parametrosCalculo.invalidateCotas(false);
                        return;
                    } else {
                        this.$refs.parametrosCalculo.invalidateCotas(true);
                    }

                    if(!this.$refs.parametrosCalculo.isValid()) {
                        return;
                    }

                    this.$refs.wizard.nextTab();
                }
            },
            validarDatasRequisicao() {
                this.$refs.parametrosCalculo.datasCorrecaoObrigatorias(true);
                this.$refs.parametrosCalculo.datasJurosObrigatorias(true);
                if(this.requisicao.deduzirPagamentos != true && this.requisicao.indiceCorrecao != null &&
                        (this.requisicao.inicioCorrecao == null || this.requisicao.fimCorrecao == null)) {
                    this.$refs.parametrosCalculo.datasCorrecaoObrigatorias(false);
                    return false;
                } else if(this.requisicao.indiceJuros != null &&
                        (this.requisicao.inicioJuros == null || this.requisicao.fimJuros == null)) {
                    this.$refs.parametrosCalculo.datasJurosObrigatorias(false);
                    return false;
                }

                return true;
            },

            async voltar() {
                this.$refs.wizard.reset();
            },

            async consultarComScroll() {
                this.currentScroll = document.documentElement.scrollTop;
                if (this.updated) {
                    this.consultar();
                }
            },

            async consultar() {
                let perPageStr = `&perPage=${this.configTable.perPage}`;
                if (this.configTable.perPage === 'Todos') {
                    perPageStr = '';
                    this.configTable.currentPage = 1;
                    this.configTable.rows = 0;
                }

                this.configTable.load = true;
                axios.post(`${this.urlApi}/v1/honorariosAcaoJudicial/consultar?page=${this.configTable.currentPage}${perPageStr}&sortField=${this.configTable.sortField}&sortOrder=${this.configTable.sortOrder}`, this.filtros, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': this.token
                    }
                }).then(response => {
                    this.items = response.data.resultado;
                    for(var i = 0; i < this.selecteds.length; i++) {
                        for (var j = 0; j < this.items.length; j++) {
                            if (this.items[j].id == this.selecteds[i].id) {
                                this.selecteds[i] = this.items[j];
                            }
                        }
                    }
                    if (this.configTable.perPage !== 'Todos') {
                        this.configTable.rows = response.data.rows;
                        this.configTable.lastPage = Math.ceil(this.configTable.rows / this.configTable.perPage);
                    } else {
                        this.configTable.lastPage = 1;
                    }

                    if(this.currentScroll != null) {
                        setTimeout(()=>{
                            document.documentElement.scrollTop = this.currentScroll;
                            this.currentScroll = null;
                        }, 100);
                    }
                }).catch((error) => {
                    this.exibirErro(error)
                }).finally(() => {
                    this.configTable.load = false;
                })
            },

            async listarTodos() {
                this.configTable.load = true;

                let filtrosTemp = {
                    ... this.filtros
                };

                filtrosTemp.situacao = [7, 6];

                axios.post(`${this.urlApi}/v1/honorariosAcaoJudicial/consultar`, filtrosTemp, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': this.token
                    }
                }).then(response => {
                    this.itemsTodos = response.data.resultado;
                }).catch((error) => {
                    this.exibirErro(error)
                }).finally(() => {
                    this.configTable.load = false;
                })
            },

            openFilterPopup(campo, tipo, values, mascara, event) {
                if(document.getElementById('popup').style.display == 'block'
                    && this.filtro.campoFiltro == campo) {
                    this.$refs.compFiltro.closeFilterPopup();
                } else {
                    this.filtro.tipo = tipo;
                    this.filtro.campoFiltro = campo;
                    this.filtro.mascara = mascara;
                    if(this.filtro.campoFiltro == 'Requisição') {
                        this.filtro.campoMascara = this.filtros.numeroRequisicao;
                    } else if(this.filtro.campoFiltro == 'Devedor') {
                        this.filtro.filtrarEm = this.filtros.filtrarContribuinte;
                        this.filtro.campoTexto = this.filtros.contribuinte;
                    } else if(this.filtro.campoFiltro == 'Data de Geração') {
                        this.filtro.filtrarEm = this.filtros.filtrarDataEmissao;
                        this.filtro.campoData = this.filtros.dataEmissao;
                    } else if(this.filtro.campoFiltro == 'Forma de Pagamento') {
                        this.filtro.campoCheckbox = this.filtros.formaPagamento;
                    } else if(this.filtro.campoFiltro == 'Tipo de Pagamento') {
                        this.filtro.campoCheckbox = this.filtros.tipoPagamento;
                    } else if(this.filtro.campoFiltro == 'Valor Pago (R$)') {
                        this.filtro.filtrarEm = this.filtros.filtrarValor;
                        this.filtro.campoTexto = this.filtros.valor;
                    } else if(this.filtro.campoFiltro == 'Situação da Requisição') {
                        this.filtro.campoCheckbox = this.filtros.situacao;
                    }

                    if(this.filtro.tipo == "checkbox") {
                        this.filtro.listaValores = values;
                    } else if(values != null && values != "") {
                        this.filtro.listaValores = values.split(',');
                    }

                    this.$refs.compFiltro.openCloseFilterPopup(event);
                }
            },
            filtrarResultados(limpar) {
                if(limpar) {
                    this.filtro.filtrarEm = null;
                    this.filtro.campoTexto = null;
                    this.filtro.campoData = null;
                    this.filtro.campoRadio = null;
                    this.filtro.campoCheckbox = null;
                    this.filtro.campoMascara = null;
                }

                if(this.filtro.campoCheckbox != null && !Array.isArray(this.filtro.campoCheckbox)) {
                    this.filtro.campoCheckbox = [this.filtro.campoCheckbox];
                }

                if(this.filtro.campoFiltro == 'Requisição') {
                    this.filtros.numeroRequisicao = this.filtro.campoMascara;
                } else if(this.filtro.campoFiltro == 'Devedor') {
                    this.filtros.filtrarContribuinte = this.filtro.filtrarEm;
                    this.filtros.contribuinte = this.filtro.campoTexto;
                } else if(this.filtro.campoFiltro == 'Data de Geração') {
                    this.filtros.filtrarDataEmissao = this.filtro.filtrarEm;
                    this.filtros.dataEmissao = this.filtro.campoData;
                } else if(this.filtro.campoFiltro == 'Forma de Pagamento') {
                    this.filtros.formaPagamento = this.filtro.campoCheckbox;
                } else if(this.filtro.campoFiltro == 'Tipo de Pagamento') {
                    this.filtros.tipoPagamento = this.filtro.campoCheckbox;
                } else if(this.filtro.campoFiltro == 'Valor Pago (R$)') {
                    this.filtros.filtrarValor = this.filtro.filtrarEm;
                    this.filtros.valor = this.filtro.campoTexto;
                } else if(this.filtro.campoFiltro == 'Situação da Requisição') {
                    this.filtros.situacao = this.filtro.campoCheckbox;
                }

                this.configTable.currentPage = 1;

                this.consultar();
            },
            ordenarResultados(order) {
                if(this.filtro.campoFiltro == 'Requisição') {
                    this.configTable.sortField = 'requisicao.numerorequisicao';
                } else if(this.filtro.campoFiltro == 'Devedor') {
                    this.configTable.sortField = 'requisicao.nomecontribuinte';
                } else if(this.filtro.campoFiltro == 'Data de Geração') {
                    this.configTable.sortField = 'requisicao.dataemissao';
                } else if(this.filtro.campoFiltro == 'Forma de Pagamento') {
                    this.configTable.sortField = 'requisicao.formapagamento';
                } else if(this.filtro.campoFiltro == 'Tipo de Pagamento') {
                    this.configTable.sortField = 'requisicao.tipopagamento';
                } else if(this.filtro.campoFiltro == 'Valor Pago (R$)') {
                    this.configTable.sortField = 'requisicao.valorpago';
                } else if(this.filtro.campoFiltro == 'Situação da Requisição') {
                    this.configTable.sortField = 'requisicao.situacao';
                }

                this.configTable.sortOrder = order;

                this.consultar();
            },
            limparDevedor() {
                this.devedor = {
                    codDevedor: null,
                    cpfCnpj: null,
                    nome: null,
                    cota: null,
                }
            },
            limparAnexos() {
                this.requisicao.arquivos = [];
            },
            executeUpload(arquivoConvertido) {
                this.requisicao.arquivos.push(arquivoConvertido);
            },
            excluirArquivo(arquivo) {
                const index = this.requisicao.arquivos.indexOf(arquivo);
                this.requisicao.arquivos.splice(index, 1);
            },
            sair() {
                this.$router.push({path: '/honorarios'});
            },
            async exportarMemoria() {
                let requisicaoTemp = {
                        codRequisicaoRepresentacaoJudicial: this.requisicao.codRequisicaoRepresentacaoJudicial,
                        honorarioFixo: this.requisicao.honorarioFixo,
                        valorFixo: this.tratarCamposNumericos(this.requisicao.valorFixo),
                        valorBaseCalculo: this.tratarCamposNumericos(this.requisicao.valorBaseCalculo),
                        percentual: this.requisicao.percentual,
                        valorIndice: this.tratarCamposNumericos(this.requisicao.valorIndice),
                        dataSentenca: this.requisicao.dataSentenca,
                        salarioMinimo: this.tratarCamposNumericos(this.requisicao.salarioMinimo),
                        quantidadeSalarios: this.requisicao.quantidadeSalarios,
                        indiceCorrecao: this.requisicao.indiceCorrecao,
                        indiceJuros: this.requisicao.indiceJuros,
                        inicioCorrecao: this.requisicao.inicioCorrecao,
                        inicioJuros: this.requisicao.inicioJuros,
                        fimCorrecao: this.requisicao.fimCorrecao,
                        fimJuros: this.requisicao.fimJuros,
                        multaArtCpc: this.requisicao.multaArtCpc,
                        honorariosArtCpc: this.requisicao.honorariosArtCpc,
                        deduzirPagamentos: this.requisicao.deduzirPagamentos,
                        tipoPagamento: this.requisicao.tipoPagamento,
                        regraParcelamento: this.requisicao.regraParcelamento,
                        numeroParcelas: this.requisicao.numeroParcelas,
                        numeroParcelasFixo: this.requisicao.numeroParcelasFixo,
                        indiceReajuste: this.requisicao.indiceReajuste,
                        formaPagamento: this.requisicao.formaPagamento,
                        deliberacao: this.requisicao.deliberacao,
                        sid: this.requisicao.sid,
                        valorHonorariosArtigo: this.requisicao.valorHonorariosArtigo,
                        numeroMinimoParcelas: this.requisicao.numeroMinimoParcelas,
                        numeroMaximoParcelas: this.requisicao.numeroMaximoParcelas,
                        valorJuros: this.requisicao.valorJuros,
                        valorCorrecao: this.requisicao.valorCorrecao,
                        requisicoesDeducao: this.requisicao.requisicoesDeducao,
                        valoresAnteriores: this.requisicao.valoresAnteriores,
                        enviarDocumentacao: this.requisicao.enviarDocumentacao,
                        emitirTermo: this.requisicao.emitirTermo,
                        arquivos: this.requisicao.arquivos,
                        setor: (this.requisicao.setor != null ? this.requisicao.setor.codSetor : null),
                        procurador: this.requisicao.procurador,
                        email: this.requisicao.email,
                };

                requisicaoTemp.cnj = this.filtros.cnj;

                requisicaoTemp.devedor = this.devedor;
                requisicaoTemp.devedor.cota = this.tratarCamposNumericos(requisicaoTemp.devedor.cota);
                requisicaoTemp.devedores = this.devedores;
                requisicaoTemp.devedores.forEach(value => {
                    value.cota = this.tratarCamposNumericos(value.cota);
                });

                if(requisicaoTemp.inicioJuros != null && requisicaoTemp.inicioJuros._i != null) {
                    requisicaoTemp.inicioJuros = requisicaoTemp.inicioJuros._i;
                }
                if(requisicaoTemp.inicioJuros != null && requisicaoTemp.inicioJuros.indexOf("-") >= 0) {
                    requisicaoTemp.inicioJuros = requisicaoTemp.inicioJuros.toString().replace("-", "/");
                }
                if(requisicaoTemp.fimJuros != null && requisicaoTemp.fimJuros._i != null) {
                    requisicaoTemp.fimJuros = requisicaoTemp.fimJuros._i;
                }
                if(requisicaoTemp.fimJuros != null && requisicaoTemp.fimJuros.indexOf("-") >= 0) {
                    requisicaoTemp.fimJuros = requisicaoTemp.fimJuros.toString().replace("-", "/");
                }
                if(requisicaoTemp.inicioCorrecao != null && requisicaoTemp.inicioCorrecao._i != null) {
                    requisicaoTemp.inicioCorrecao = requisicaoTemp.inicioCorrecao._i;
                }
                if(requisicaoTemp.inicioCorrecao != null && requisicaoTemp.inicioCorrecao.indexOf("-") >= 0) {
                    requisicaoTemp.inicioCorrecao = requisicaoTemp.inicioCorrecao.toString().replace("-", "/");
                }
                if(requisicaoTemp.fimCorrecao != null && requisicaoTemp.fimCorrecao._i != null) {
                    requisicaoTemp.fimCorrecao = requisicaoTemp.fimCorrecao._i;
                }
                if(requisicaoTemp.fimCorrecao != null && requisicaoTemp.fimCorrecao.indexOf("-") >= 0) {
                    requisicaoTemp.fimCorrecao = requisicaoTemp.fimCorrecao.toString().replace("-", "/");
                }

                this.$refs.loading.showLoading();
                axios.post(`${this.urlApi}/v1/honorariosAcaoJudicial/exportarMemoriaCalculo`, requisicaoTemp, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': this.token
                    },
                    responseType: 'arraybuffer'
                })
                    .then(response => {
                        let blob = new Blob([response.data], { type: 'application/pdf' });
                        let link = document.createElement('a');
                        link.href = window.URL.createObjectURL(blob);
                        link.download = 'MemoriaCalculo.pdf';
                        link.click();
                    }).finally(() => {
                    this.$refs.loading.hideLoading();
                })
            },
            async salvar(enviar) {
                this.$store.commit("setMessages", {});

                this.$refs.abaConfirmar.validarSetor(true);
                if(this.verificarValorVazio(this.requisicao.setor)) {
                    this.$refs.abaConfirmar.validarSetor(false);
                    return;
                }
                this.$refs.abaConfirmar.validarProcurador(true);
                if(enviar && this.requisicao.procurador == null) {
                    this.$refs.abaConfirmar.validarProcurador(false);
                    return;
                }
                if (!this.$refs.abaConfirmar.validarEmailDevedor()) {
                    return;
                }

                this.finalizarConfirmar(enviar);
            },
            openPdfWithAuth(pdfUrl, authToken) {
                // 1. Fetch the PDF as a blob with the Authorization header
                fetch(pdfUrl, {
                    headers: {
                        'Authorization': authToken,
                    },
                }).then(response => {
                    if (!response.ok) {
                        throw new Error('Network response was not ok');
                    }
                    return response.blob();
                }).then(blob => {
                    // 2. Create a local URL from the blob
                    const fileURL = window.URL.createObjectURL(blob);
                    // 3. Set src element to the new URL
                    document.getElementById('guiaPdf').src = fileURL;
                }).catch(error => {
                    console.error('Error fetching the PDF:', error);
                });
            },
            async finalizarConfirmar(enviar) {
                this.$refs['modal-confirmar-data'].hide();

                let requisicaoTemp = {
                    codRequisicaoRepresentacaoJudicial: this.requisicao.codRequisicaoRepresentacaoJudicial,
                    honorarioFixo: this.requisicao.honorarioFixo,
                    valorFixo: this.tratarCamposNumericos(this.requisicao.valorFixo),
                    valorBaseCalculo: this.tratarCamposNumericos(this.requisicao.valorBaseCalculo),
                    percentual: this.requisicao.percentual,
                    valorIndice: this.tratarCamposNumericos(this.requisicao.valorIndice),
                    dataSentenca: this.requisicao.dataSentenca,
                    salarioMinimo: this.tratarCamposNumericos(this.requisicao.salarioMinimo),
                    quantidadeSalarios: this.requisicao.quantidadeSalarios,
                    indiceCorrecao: this.requisicao.indiceCorrecao,
                    indiceJuros: this.requisicao.indiceJuros,
                    inicioCorrecao: this.requisicao.inicioCorrecao,
                    inicioJuros: this.requisicao.inicioJuros,
                    fimCorrecao: this.requisicao.fimCorrecao,
                    fimJuros: this.requisicao.fimJuros,
                    multaArtCpc: this.requisicao.multaArtCpc,
                    honorariosArtCpc: this.requisicao.honorariosArtCpc,
                    deduzirPagamentos: this.requisicao.deduzirPagamentos,
                    tipoPagamento: this.requisicao.tipoPagamento,
                    regraParcelamento: this.requisicao.regraParcelamento,
                    numeroParcelas: this.requisicao.numeroParcelas,
                    numeroParcelasFixo: this.requisicao.numeroParcelasFixo,
                    indiceReajuste: this.requisicao.indiceReajuste,
                    formaPagamento: this.requisicao.formaPagamento,
                    deliberacao: this.requisicao.deliberacao,
                    sid: this.requisicao.sid,
                    valorHonorariosArtigo: this.requisicao.valorHonorariosArtigo,
                    numeroMinimoParcelas: this.requisicao.numeroMinimoParcelas,
                    numeroMaximoParcelas: this.requisicao.numeroMaximoParcelas,
                    valorJuros: this.requisicao.valorJuros,
                    valorCorrecao: this.requisicao.valorCorrecao,
                    requisicoesDeducao: this.requisicao.requisicoesDeducao,
                    valoresAnteriores: this.requisicao.valoresAnteriores,
                    enviarDocumentacao: this.requisicao.enviarDocumentacao,
                    emitirTermo: this.requisicao.emitirTermo,
                    arquivos: this.requisicao.arquivos,
                    setor: (this.requisicao.setor != null ? this.requisicao.setor.codSetor : null),
                    procurador: this.requisicao.procurador,
                    dataTransferencia: this.requisicao.dataTransferencia,
                    codPagamento: this.requisicao.pagamento.codPagamento,
                    email: this.requisicao.email,
                    observacoes: this.requisicao.observacoes || '',
                    titularReceita: this.requisicao.titularReceita,
                };

                requisicaoTemp.cnj = this.filtros.cnj;
                requisicaoTemp.devedor = this.devedor;
                requisicaoTemp.devedor.cota = this.tratarCamposNumericos(requisicaoTemp.devedor.cota);

                requisicaoTemp.devedores = this.devedores;
                requisicaoTemp.devedores.forEach(value => {
                    value.cota = this.tratarCamposNumericos(value.cota);
                });

                requisicaoTemp.enviarProcurador = enviar;

                if(requisicaoTemp.inicioJuros != null && requisicaoTemp.inicioJuros._i != null) {
                    requisicaoTemp.inicioJuros = requisicaoTemp.inicioJuros._i;
                }
                if(requisicaoTemp.inicioJuros != null && requisicaoTemp.inicioJuros.indexOf("-") >= 0) {
                    requisicaoTemp.inicioJuros = requisicaoTemp.inicioJuros.toString().replace("-", "/");
                }
                if(requisicaoTemp.fimJuros != null && requisicaoTemp.fimJuros._i != null) {
                    requisicaoTemp.fimJuros = requisicaoTemp.fimJuros._i;
                }
                if(requisicaoTemp.fimJuros != null && requisicaoTemp.fimJuros.indexOf("-") >= 0) {
                    requisicaoTemp.fimJuros = requisicaoTemp.fimJuros.toString().replace("-", "/");
                }
                if(requisicaoTemp.inicioCorrecao != null && requisicaoTemp.inicioCorrecao._i != null) {
                    requisicaoTemp.inicioCorrecao = requisicaoTemp.inicioCorrecao._i;
                }
                if(requisicaoTemp.inicioCorrecao != null && requisicaoTemp.inicioCorrecao.indexOf("-") >= 0) {
                    requisicaoTemp.inicioCorrecao = requisicaoTemp.inicioCorrecao.toString().replace("-", "/");
                }
                if(requisicaoTemp.fimCorrecao != null && requisicaoTemp.fimCorrecao._i != null) {
                    requisicaoTemp.fimCorrecao = requisicaoTemp.fimCorrecao._i;
                }
                if(requisicaoTemp.fimCorrecao != null && requisicaoTemp.fimCorrecao.indexOf("-") >= 0) {
                    requisicaoTemp.fimCorrecao = requisicaoTemp.fimCorrecao.toString().replace("-", "/");
                }

                requisicaoTemp.enviarProcurador = enviar;
                requisicaoTemp.faixas = [];
                for(var i = 0; i < this.faixas.length; i++) {
                    requisicaoTemp.faixas.push({
                        ... this.faixas[i]
                    });
                    requisicaoTemp.faixas[i].percentual = this.tratarCamposNumericos(requisicaoTemp.faixas[i].percentual);
                }

                this.$refs.loading.showLoading();
                axios.post(`${this.urlApi}/v1/honorariosAcaoJudicial/salvar`, requisicaoTemp, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': this.token
                    }
                }).then(response => {
                    this.retorno = response.data;
                    this.arquivoPdf = this.retorno.arquivo;
                    this.openPdfWithAuth(`${this.urlApi}/v1/honorariosAcaoJudicial/obterArquivoRequisicao/publico/${this.retorno.id}/${this.arquivoPdf}`, this.token);
                    this.$refs.wizard.nextTab();
                }).catch((error) => {
                    this.exibirErro(error)
                }).finally(() => {
                    this.$refs.loading.hideLoading();
                });
            },

            async obterHonorariosAcaoJudicial(id, avancarDois) {
                this.$refs.loading.showLoading();
                await axios.get(`${this.urlApi}/v1/honorariosAcaoJudicial/obter/` + id, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': this.token
                    }
                }).then(response => {
                    this.requisicao = {
                        ...response.data
                    };
                    if(this.requisicao.setor != null) {
                        this.requisicao.setor = {'codSetor': this.requisicao.setor};
                    }
                    if(this.requisicao.inicioJuros != null) {
                        this.requisicao.inicioJuros = this.requisicao.inicioJuros.toString().replace("/", "-");
                    }
                    if(this.requisicao.inicioCorrecao != null) {
                        this.requisicao.inicioCorrecao = this.requisicao.inicioCorrecao.toString().replace("/", "-");
                    }
                    if(this.requisicao.fimJuros != null) {
                        this.requisicao.fimJuros = this.requisicao.fimJuros.toString().replace("/", "-");
                    }
                    if(this.requisicao.fimCorrecao != null) {
                        this.requisicao.fimCorrecao = this.requisicao.fimCorrecao.toString().replace("/", "-");
                    }

                    let valorFixo = null;
                    if(this.requisicao.valorFixo != null) {
                        valorFixo = this.requisicao.valorFixo.toString();
                        if(valorFixo.split(".").length <= 1) {
                            valorFixo += "00";
                        } else if(valorFixo.split(".")[1].length == 1) {
                            valorFixo += "0";
                        }
                    }

                    this.requisicao.valorFixo = this.formatarMonetario(valorFixo != null ? valorFixo.toString().replace(".", ",") : valorFixo);

                    let valor = null;
                    if(this.requisicao.valorBaseCalculo != null) {
                        valor = this.requisicao.valorBaseCalculo.toString();
                        if(valor.split(".").length <= 1) {
                            valor += "00";
                        } else if(valor.split(".")[1].length == 1) {
                            valor += "0";
                        }
                    }

                    this.requisicao.valorBaseCalculo = this.formatarMonetario(valor);
                    this.requisicao.valorIndice = this.formatarDecimalPositivo(this.requisicao.valorIndice != null ? this.requisicao.valorIndice.toString().replace(".", ",") : this.requisicao.valorIndice, 3, 3);
                    this.requisicao.numeroParcelasFixo = this.formatarDecimal(this.requisicao.numeroParcelasFixo, 3, 0);

                    this.filtros.cnj = response.data.cnj;
                    this.devedor = response.data.devedor;
                    this.$refs.wizard.nextTab();

                    if(avancarDois) {
                        this.$refs.wizard.nextTab();
                    }

                    response.data.requisicoesDeducao.forEach(el => {
                        this.selecteds.push({
                            id: el
                        });
                    });

                    this.selecteds = [];

                    setTimeout(()=>{
                        this.$refs.parametrosCalculo.obterValoresCorrecao();
                        this.$refs.parametrosCalculo.obterValoresJuros();
                        this.$refs.parametrosCalculo.executarCalculos();
                        this.$refs.parametrosCalculo.alterarMinDataCorrecao();
                        this.$refs.parametrosCalculo.alterarMinDataJuros();
                        this.atribuirPagamentoRequisicao();

                        this.requisicao.tipoPagamento = response.data.tipoPagamento;
                        this.requisicao.regraParcelamento = response.data.regraParcelamento;
                        this.requisicao.numeroParcelas = response.data.numeroParcelas;
                        this.requisicao.numeroParcelasFixo = response.data.numeroParcelasFixo;
                        this.requisicao.indiceReajuste = response.data.indiceReajuste;
                        this.requisicao.formaPagamento = response.data.formaPagamento;
                        this.requisicao.deliberacao = response.data.deliberacao;
                        this.requisicao.sid = response.data.sid;

                        this.atribuirStickyTopo(true);
                    }, 200);
                }).catch((error) => {
                    this.exibirErro(error)
                }).finally(() => {
                    this.$refs.loading.hideLoading();
                });
            },
            async listarArtigo85() {
                axios.get(`${this.urlApi}/v1/honorariosAcaoJudicial/listarFaixasArtigo85`, {
                headers: {
                    'Authorization': this.token
                }
            }).then(response => {
                    this.faixas = response.data
                })
            },

            limparFiltros() {
                this.filtros = {
                    numeroRequisicao: null,
                    cnj: this.filtros.cnj,
                    filtrarContribuinte: null,
                    contribuinte: null,
                    filtrarDataEmissao: null,
                    dataEmissao: null,
                    tipoPagamento: null,
                    formaPagamento: null,
                    filtrarValor: null,
                    valor: null,
                    situacao: null,
                    titularReceita: 0
                };

                this.consultar();
            },

            voltarFaixas(faixasTemp) {
                this.faixas = faixasTemp;
            },

            completarCnj() {
                this.cnjValido = true;
                if (this.filtros.cnj != '' && this.onlyNumber(this.filtros.cnj).length < 20) {
                    this.filtros.cnj = this.mascaraCnj(this.onlyNumber(this.filtros.cnj).padStart(20, '0'));
                }
            },

            enterCnj() {
                document.getElementById("btnProxima").click();
            },

            atribuirStickyTopo(force) {
                if(force || this.$refs.wizard.activeTabIndex >= 2) {
                    let anchor = document.querySelector('.wizard-navigation');
                    let divTopo = document.createElement('div');
                    divTopo.id = "div-topo";
                    divTopo.classList.add("topo-sticky");
                    divTopo.classList.add("background-scroller");
                    anchor.insertAdjacentElement('afterbegin', divTopo);

                    let barraWizard = document.getElementsByClassName('wizard-progress-with-circle')[0];
                    let progressoWizard = document.getElementsByClassName('wizard-nav wizard-nav-pills')[0];
                    divTopo.appendChild(barraWizard);
                    divTopo.appendChild(progressoWizard);
                } else {
                    var element = document.getElementById("div-topo");
                    if(element != null) {
                        element.classList.remove("topo-sticky");
                    }
                }
            },
            async listarRegrasPagamento() {
                let titularReceita = this.requisicao.titularReceita ? this.requisicao.titularReceita : 0;
                axios.get(`${this.urlApi}/v1/honorariosAcaoJudicial/listarRegrasPagamento/${titularReceita}`, {
                headers: {
                    'Authorization': this.token
                }
            }).then(response => {
                    this.regrasPagamento = response.data;
                    this.atribuirPagamentoRequisicao();
                    this.$refs.parametrosCalculo.obterQuantidadeParcelas();
                })
            },
            atribuirPagamentoRequisicao() {
                if(this.requisicao.codPagamento != null) {
                    this.regrasPagamento.forEach(value => {
                        if(value.codPagamento == this.requisicao.codPagamento) {
                            this.requisicao.pagamento = value;
                        }
                    });

                    this.$refs.parametrosCalculo.obterQuantidadeParcelas();
                    this.$refs.parametrosCalculo.mudarPagamento(true);
                }
            },
            excluirDevedor() {
                let indexUltimoDevedor = this.devedores.length - 1;

                this.devedor = {
                    ...this.devedores[indexUltimoDevedor]
                };

                this.devedores.splice(indexUltimoDevedor, 1);

            },
            alterarSubmeterProcurador(valorCheckbox) {
                this.submeterProcurador = valorCheckbox;
            },
            alterarValidadeValor(valido) {
                this.validations.valor.valid = valido;
            },
            acionarEnter(e) {
                if(this.$refs.wizard.activeTabIndex == 1 && e.key == 'Enter') {
                    document.getElementById("btnProximaTabela").click();
                }
            },
            async obterEmailCes() {
                axios.get(`${this.urlApi}/v1/honorariosAcaoJudicial/obterEmailCes`, {
                    headers: {
                        'Authorization': this.token
                    }
                }).then(response => {
                    this.emailCes = response.data;
                })
            },
            alterarTitularReceita(titularReceita) {
                this.filtros.titularReceita = titularReceita;
                this.requisicao.titularReceita = titularReceita;
                this.listarRegrasPagamento();
            },
        },
        mounted() {
            this.$store.commit("setMessages", {});
            this.urlApi = process.env.VUE_APP_ROOT_API;
            this.token = JSON.parse(this.$store.getters.getUser).access_token;

            let honorariosAcaoJudicial = this.$store.getters.getHonorariosAcaoJudicial;
            if(honorariosAcaoJudicial) {
                this.$store.commit('setHonorariosAcaoJudicial', null);
                this.obterHonorariosAcaoJudicial(honorariosAcaoJudicial, true);
            }

            this.listarArtigo85();
            this.listarRegrasPagamento();
            this.obterEmailCes();

            let userData = JSON.parse(this.$store.getters.getUser);
            this.acessoLimitado = true;
            if (userData.groups) {
                for (let i = 0; i < userData.groups.length; i++) {
                    if(userData.groups[i] == 'SFEPGE-ADMINISTRADOR') {
                        this.acessoLimitado = false;
                    } else if(userData.groups[i] == 'SFEPGE-TESOUREIRO') {
                        this.acessoLimitado = false;
                    } else if(userData.groups[i] == 'SFEPGE-PROCURADOR') {
                        this.acessoLimitado = false;
                    }
                }
            }

            setTimeout(()=>{
                document.getElementsByClassName('cnj')[0].focus();
            }, 500);

            window.addEventListener("keypress", this.acionarEnter);
        },
    }
</script>
